module.exports = __webpack_public_path__ + "static/img/business1.fe6f6b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/img/business1.png
// module id = nm1X
// module chunks = 1